import { useCallback, useEffect, useRef } from 'react';
import { useFormikContext } from 'formik';
import { debounce } from '@util/debounce';

interface AutoSaveProps<T> {
  onSave: (values: T, isValid: boolean) => void;
}

const AutoSave = <T extends unknown>({ onSave }: AutoSaveProps<T>) => {
  const formik = useFormikContext<T>();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSave = useCallback(
    debounce((ctx: typeof formik) => onSave(ctx.values, ctx.isValid), 500),
    []
  );

  const mounted = useRef(false);

  useEffect(() => {
    if (mounted.current) {
      mounted.current = true;
      return;
    }
    // Occasionally formik is stupid and doesn't set dirty even when touched is full, so we'll just check both
    if (formik.dirty || Object.keys(formik.touched).length !== 0) {
      debouncedSave(formik);
    }
  }, [debouncedSave, formik]);

  return null;
};

export default AutoSave;
